import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  TemplateRef,
} from '@angular/core';

/**
 * Accordion Panel Component
 */
@Component({
  selector: 'atx-accordion-panel',
  templateUrl: './accordion-panel.component.html',
  animations: [
    trigger('slideInOut', [
      state(
        'open',
        style({
          height: '*',
        }),
      ),
      state(
        'closed',
        style({
          height: '0rem',
        }),
      ),
      transition('open=>closed', animate('300ms ease')),
      transition('closed=>open', animate('300ms ease')),
    ]),
  ],
  styleUrls: ['./accordion-panel.component.scss'],
  // tslint:disable-next-line: prefer-on-push-component-change-detection
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false,
})
export class AccordionPanelComponent implements OnInit, OnChanges {
  /**
   * add the capability to pre open a given panel
   */
  @Input() public open = false;

  @Input() public animate = false;

  @Input() public ignoreChangeTriggers = false;

  @Input() public content: string | TemplateRef<unknown>;

  /**
   * Emits the panel's id and state to the parent
   */
  @Output() public toggled = new EventEmitter<{
    id: string;
    open: boolean;
  }>();

  /**
   * Attached to panel body class
   */
  @Input() public panelBodyClass: string;

  /**
   * Holds a unique value to act as an id
   * of the panel (mandatory if Accordion.closeOthers = true)
   */
  @Input() public panelId: string;

  /**
   * Emmits the panel's id and state to the parent
   */
  public toggleMenu() {
    this.toggleEmit(!this.open);
  }

  public collapse() {
    this.open = false;
    this.toggleEmit(false);
  }

  public expand() {
    this.open = true;
    this.toggleEmit(true);
  }

  /**
   * If the panel is initialized open it should let the parent accordion know.
   */
  public ngOnInit() {
    if (this.open) {
      this.toggleEmit(this.open);
    }
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (this.ignoreChangeTriggers) {
      return;
    }

    if (changes.open) {
      this.toggleEmit(changes.open.currentValue);
    }
  }

  private toggleEmit(open: boolean) {
    this.toggled.emit({ id: this.panelId, open });
  }

  public isTemplate(item: string | TemplateRef<unknown>) {
    return item instanceof TemplateRef;
  }
}
